module.exports = __webpack_public_path__ + "img/Coin-all-min.07dd0deb.png";